<template>
  <div class="week">
    <pitchtype-mini-availability-calendar-day
      v-for="(day, index) in days"
      :key="`${parentKey}-${index}`"
      :day="day"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { PitchtypeMiniAvailabilityCalendarDayWithStatusesInfo } from '../schemas'

@Component
class PitchtypeMiniAvailabilityCalendarWeek extends Vue {
  @Prop({ required: true })
  parentKey: string

  @Prop({ required: true })
  days: PitchtypeMiniAvailabilityCalendarDayWithStatusesInfo[]
}

export default toNative(PitchtypeMiniAvailabilityCalendarWeek)
</script>

<style scoped>
.week {
  display: flex;
  flex-wrap: nowrap;
  gap: 1px;
}
</style>
